<template>
  <form class="form" @submit.prevent="submit">
    <div class="form__wrapper">
      <div class="form__userpic">
        <userpic :url="user && user.photo" />
      </div>
      <c-textarea v-model="text" placeholder="Напишите комментарий" :clearable="true" class="form__field" />
      <div class="form__actions">
        <button
          v-b-popover.html="{
            id: 'comment-form-add-file',
            container: '#app',

            content: 'Добавить файл',
            trigger: 'hover',
            placement: 'top',
          }"
          type="button"
          class="form__attach"
          :disabled="fileLinks.length + files.length >= 10"
          @click="chooseFiles"
        >
          <svg-icon :size="16" name="clip" />
        </button>
        <button
          v-b-popover.html="{
            id: 'comment-form-submit',
            container: '#app',

            content: 'Добавить комментарий',
            trigger: 'hover',
            placement: 'top',
          }"
          type="submit"
          class="form__submit"
          :disabled="!isValid || pending"
        >
          <svg-icon :size="15" name="submit" color="white" />
        </button>
      </div>
    </div>
    <div class="form__files" :class="{ empty: !fileLinks.length && !files.length }">
      <file-loader
        ref="loader"
        v-model="files"
        format="images,pdf,docs,video"
        actions="loadFiles,preview"
        :links="fileLinks"
        :limit="10"
        @changeLinks="fileLinks = $event"
      ></file-loader>
    </div>
  </form>
</template>

<script>
import { mapState } from "vuex";

import CTextarea from "@/components/controls/textarea";
import FileLoader from "@/components/file-loader";
import Userpic from "@/components/user/userpic";
import SvgIcon from "@/components/svg-icon";

export default {
  components: {
    CTextarea,
    FileLoader,
    Userpic,
    SvgIcon,
  },

  props: ["comment", "pending"],

  data() {
    return {
      isSubmitted: false,

      text: "",
      files: [],
      fileLinks: [],
    };
  },

  computed: {
    ...mapState(["user"]),

    oldFiles() {
      return this.fileLinks || [];
    },

    isValid() {
      return this.files.length || this.fileLinks.length || this.text.trim().length;
    },
  },

  created() {
    if (this.comment) {
      this.setInitialData(this.comment);
    }
  },

  methods: {
    setInitialData(data) {
      this.text = data.message;
      this.fileLinks = data.files.map((file) => ({ id: file.id, url: file.name }));
    },

    getParams() {
      const params = {
        message: this.text,
        files: this.files,
      };

      if (this.comment && this.comment.files.length) {
        const oldFiles = this.oldFiles.map((file) => file.id);
        params.oldFiles = oldFiles;
      }

      return params;
    },

    submit() {
      this.isSubmitted = true;

      if (!this.isValid) return;

      this.$emit("submitted", this.getParams());
    },

    reset() {
      this.isSubmitted = false;
      this.text = "";
      this.$refs.loader.clear();
    },

    chooseFiles() {
      this.$refs.loader.chooseFiles();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.form {
  &__wrapper {
    display: flex;
  }

  &__userpic,
  &__actions {
    flex-shrink: 0;
  }

  &__userpic {
    margin-right: 10px;
  }

  &__field {
    flex-grow: 1;
    margin-right: 15px;

    /deep/ {
      textarea {
        font-size: 13px;
        line-height: 1.4;

        &::placeholder {
          color: $color-label;
          font-size: 13px;
        }
      }
    }
  }

  &__actions {
    display: flex;
    align-items: flex-start;
  }

  &__attach,
  &__submit {
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;

    &,
    &:hover,
    &:focus {
      outline: none;
    }

    &[disabled] {
      opacity: 0.5;
    }
  }

  &__attach {
    margin-right: 10px;
    background: transparent;
    border: 1px solid #d3d8df;
  }

  &__submit {
    background: $color-primary;
    border: none;
  }

  &__files {
    margin-top: 12px;
    margin-left: 42px;

    &.empty {
      margin-top: 0;
    }
  }

  /deep/ {
    .file-loader {
      &__add {
        display: none;
      }
      .file-preview {
        width: 55px;

        &-img {
          height: 50px;

          &__icon {
            width: 15px;
            height: 15px;
          }
        }

        &__name {
          display: none;
        }
      }
    }
  }
}
</style>
